import { Component, OnInit } from '@angular/core';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService.setTheme('default');
  }

  applyTheme($event: Event): void {
    const target = $event.target as HTMLInputElement;
    this.themeService.setTheme(target.value);
  }
}
